import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import { initialState } from './initialState'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'

Vue.use(Vuex)

export default new Vuex.Store({
  state: initialState,
  mutations,
  actions,
  getters,
  plugins: [createPersistedState({ storage: window.sessionStorage })]
})
